"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _excludeVariablesFromRoot = _interopRequireDefault(require("./excludeVariablesFromRoot"));
var _default = function(theme) {
    return function(colorScheme, css) {
        var root = theme.rootSelector || ':root';
        var selector = theme.colorSchemeSelector;
        var rule = selector;
        if (selector === 'class') {
            rule = '.%s';
        }
        if (selector === 'data') {
            rule = '[data-%s]';
        }
        if ((selector === null || selector === void 0 ? void 0 : selector.startsWith('data-')) && !selector.includes('%s')) {
            // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
            rule = "[".concat(selector, '="%s"]');
        }
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                var excludedVariables = {};
                (0, _excludeVariablesFromRoot.default)(theme.cssVarPrefix).forEach(function(cssVar) {
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') {
                    var _obj;
                    return _obj = {}, _define_property(_obj, root, css), _define_property(_obj, "@media (prefers-color-scheme: dark)", _define_property({}, root, excludedVariables)), _obj;
                }
                if (rule) {
                    var _obj1;
                    return _obj1 = {}, _define_property(_obj1, rule.replace('%s', colorScheme), excludedVariables), _define_property(_obj1, "".concat(root, ", ").concat(rule.replace('%s', colorScheme)), css), _obj1;
                }
                return _define_property({}, root, _object_spread({}, css, excludedVariables));
            }
            if (rule && rule !== 'media') {
                return "".concat(root, ", ").concat(rule.replace('%s', String(colorScheme)));
            }
        } else if (colorScheme) {
            if (rule === 'media') {
                return _define_property({}, "@media (prefers-color-scheme: ".concat(String(colorScheme), ")"), _define_property({}, root, css));
            }
            if (rule) {
                return rule.replace('%s', String(colorScheme));
            }
        }
        return root;
    };
};
exports.default = _default;
